import { Title, Container, Button, FixedBottom, HalvaBanner } from '@/components'
import styles from './PaymentResult.module.scss'
import getLinkHref from '@/helpers/getLinkHref'
import Link from 'next/link'
import { supportPhoneLink } from '@/constants'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { RootState } from '@/store'
import { MobileApp } from '@/components/MobileApp/MobileApp'
import { DownloadAppBottomSheet } from '@/components/DownloadAppBottomSheet/DownloadAppBottomSheet'

export default function PaymentFinesSuccessPage({
  area,
}: {
  area: {
    id: string
    customising?: { button_back_color: string | null }
  } | null
}) {
  const areaHref = getLinkHref({ type: 'area', data: { id: area?.id } })
  const reduxState = useSelector<RootState, RootState>(state => state)
  const receiptLink = reduxState.stages.payment.data.receiptLink
  const router = useRouter()

  const redirectToReceiptPage = () => {
    if (receiptLink) {
      router.push(receiptLink)
    }
  }

  return (
    <>
      <section className={styles.section}>
        <Container className={styles.container}>
          <HalvaBanner />
          <div className={styles.successResultContent}>
            <img
              className={styles.icon}
              src="/images/payment-success.svg"
              alt="logo"
              width={87}
              height={87}
            />

            <Title align="center">Оплата успешно прошла</Title>
          </div>

          <FixedBottom isHide>
            <Container className={styles.buttons}>
              {receiptLink && (
                <Button
                  component="button"
                  className={styles.button}
                  onClick={redirectToReceiptPage}
                >
                  Получить чек
                </Button>
              )}

              <Link href={areaHref} passHref>
                <Button
                  component="a"
                  className={styles.button}
                  background={area?.customising?.button_back_color}
                >
                  На главную
                </Button>
              </Link>

              <Button component="a" href={supportPhoneLink} className={styles.button} isTransparent>
                Обратиться в поддержку
              </Button>
            </Container>
          </FixedBottom>

          <div className={styles.container__mobileApp}>
            <MobileApp />
          </div>
        </Container>
      </section>
      <DownloadAppBottomSheet />
    </>
  )
}
